export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium whitespace-nowrap">
                <i className="ri-flashlight-line text-sm w-4 h-4 flex items-center justify-center"></i>
                实时更新
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium whitespace-nowrap">
                <i className="ri-fire-line text-sm w-4 h-4 flex items-center justify-center"></i>
                每日爆料
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-800 text-xs font-medium whitespace-nowrap">
                <i className="ri-eye-line text-sm w-4 h-4 flex items-center justify-center"></i>
                吃瓜第一线
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4">
              51黑料 - 全网吃瓜爆料第一站
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-bold mb-5">
              最新、最快、最全的娱乐圈八卦爆料聚合平台
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              51黑料吃瓜网专为吃瓜群众打造，聚合全网最新黑料爆料、娱乐八卦与今日黑料头条。覆盖明星动态、影视综艺、网红圈层等多维度内容，每日持续更新，即点即看，不错过每一个精彩大瓜。当前热门焦点集中在近期艺人争议事件与圈内深度揭秘，吃瓜爆料在线同步，让你走在八卦第一线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500 font-heading">200+</div>
                <div className="text-xs text-foreground-500 mt-1">日均更新条数</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-500 font-heading">500+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖明星艺人</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-secondary-600 font-heading">百万</div>
                <div className="text-xs text-foreground-500 mt-1">吃瓜群众在线</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleNavClick('#topics'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-bold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-eye-line text-lg w-5 h-5 flex items-center justify-center"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-600 font-bold text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg w-5 h-5 flex items-center justify-center"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20artistic%20composition%20of%20a%20vibrant%20entertainment%20news%20studio%20with%20warm%20crimson%20and%20amber%20lighting%2C%20abstract%20geometric%20shapes%2C%20floating%20newspaper%20fragments%2C%20spotlight%20effects%2C%20cinematic%20atmosphere%2C%20clean%20background%20with%20soft%20gradients%2C%20editorial%20design%20aesthetic%2C%20high%20contrast%2C%20dramatic%20shadows&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="51黑料吃瓜爆料首页主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}